import log from 'loglevel';
import { getAuthToken } from '../auth';
import { VTO_CLOSETS_ADDRESS } from '../constants';
import { GarmentFit } from './fitTypes';

/**
 * Call get garment fit.
 * @param avatarId Avatar ID.
 * @param garmentId Garment ID.
 * @param poseId Pose ID.
 */
export async function fetchFit(
  avatarId: string,
  garmentId: string,
  poseId: string,
): Promise<GarmentFit | undefined> {
  const ENDPOINT = `${VTO_CLOSETS_ADDRESS}/v1/fits`;

  const idToken = await getAuthToken();
  const headers = {
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    'Content-Type': 'application/json',
  };

  const res = await fetch(`${ENDPOINT}?a=${avatarId}&g=${garmentId}&p=${poseId}`, {
    headers,
  });

  const { status } = res;
  if (status < 200 || status >= 400) {
    log.info(`GET ${ENDPOINT} failed with status ${status}`);
    return undefined;
  }

  return (await res.json()) as GarmentFit;
}

/**
 * Call create or retrieve garment fit.
 * @param avatarId Avatar ID.
 * @param garmentId Garment ID.
 * @param poseId Pose ID.
 */
export async function fetchPutFit(
  avatarId: string,
  garmentId: string,
  poseId: string,
): Promise<GarmentFit> {
  const ENDPOINT = `${VTO_CLOSETS_ADDRESS}/v1/fits`;

  const idToken = await getAuthToken();
  const headers = {
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    'Content-Type': 'application/json',
  };

  const body = JSON.stringify({ avatarId, garmentId, poseId });

  const res = await fetch(ENDPOINT, {
    body,
    headers,
    method: 'PUT',
  });

  const { status } = res;
  if (status < 200 || status >= 400) {
    throw new Error(`PUT ${ENDPOINT} fit failed with status ${status}`);
  }

  return (await res.json()) as GarmentFit;
}
